/* eslint-disable no-unused-vars */

import FormSchema from './formSchema'
import FormSubmission from './formSubmission'

/**
 * Creates an instance of FormSubmissionWithSchemaVM.
 * @typedef {Object} FormSubmissionWithSchemaVMType
 * @property {FormSubmission} submission
 * @property {FormSchema} schema
 */

/**
 * Represents a form submission and the associated form schema.
 * @class
 */
export default class FormSubmissionWithSchemaVM {
  /**
   * Create a new FormSubmission.
   * @param {FormSubmissionWithSchemaVMType} params
   */
  constructor(params) {
    this.submission = params.submission
      ? new FormSubmission(params.submission)
      : null
    this.schema = params.schema ? new FormSchema(params.schema) : null
  }
}
